import {BadgeCheck, CircleDollarSign, Clock, Compass, Headset, Instagram, KeyRound, Mail, RefreshCcw, ShieldCheck, TrendingDown, } from 'lucide-react'
import type { LucideProps } from 'lucide-react'

const iconMap: Record<string, React.ComponentType<LucideProps>> = {
  TrendingDown,
  Clock,
  CircleDollarSign,
  KeyRound,
  Mail,
  ShieldCheck,
  Headset,
  BadgeCheck,
  Instagram,
  RefreshCcw,
  Compass,
}

interface IconProps extends LucideProps {
  name: string
}

function Icon({ name, ...props }: IconProps) {
  const Component = iconMap[name] || ShieldCheck
  return <Component {...props} />
}

export default Icon
